import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "../../../../../../../../core/service/auth.service";
import { catchError, Observable, switchMap, throwError, finalize, take } from "rxjs";
import { StorageProducts } from "../../../../../../../../core/service/cart-apis/interfaces/cart.interface";
import { DeliveryAddress, PaymentCheckoutResponse } from "../interfaces/payload.interface";
import { environment } from "../../../../../../../../../environments/environment";
import { Store } from '@ngrx/store';
import * as ShippingActions from "../../../../../../../../store/shipping/shipping.actions";
import { selectShoppingCartId } from "../../../../../../../../store/cart/cart.selectors";
import { AppState } from "../../../../../../../../store/app.state";
import { PaymentIntentResult, Stripe } from "@stripe/stripe-js";
@Injectable({
  providedIn: "root",
})
export class ProcessPaymentService {
  products: StorageProducts[] = [];
  shippingCost: number = 0;
  timeGoogle: number = 0;
  distance: number = 0;
  textDetail: string = '';
  stripe: Stripe | null = null;
  private isPaymentInProgress = false;
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private store: Store<AppState>
  ) {
    this.store.select(state => state.shipping.time).subscribe(time => {
      this.timeGoogle = Number(time);
    })
    this.store.select(state => state.shipping.kmDistance).subscribe(distance => {
      this.distance = Number(distance);
    })
  }

  private getDeliveryAdress(): DeliveryAddress {
    const deliveryAdressData = JSON.parse(localStorage.getItem('selected_address') || '');
    return deliveryAdressData;
  }


  processPayment(paymentMethodId?: string, typePayment: number = 5): Observable<PaymentCheckoutResponse> {


    // Check if payment is already in progress
    if (this.isPaymentInProgress) {
      console.warn('Payment request already in progress. Ignoring duplicate request.');
      return throwError(() => new Error('Payment request is already in progress'));
    }

    if (!this.authService.isLoggedIn()) {
      return throwError(() => new Error('No se ha iniciado sesión'));
    }

    // Set flag to prevent duplicate requests
    this.isPaymentInProgress = true;

    const deliveryAddress = this.getDeliveryAdress();
    const tokenUser = this.authService.getToken();
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${tokenUser}`,
      'Content-Type': 'application/json'
    });

    try {
      // console.log('Processing payment with Stripe payment method ID:', paymentMethodId);
      return this.store.select(state => state.shipping,).pipe(

        // Tomar solo el primer valor para evitar múltiples solicitudes
        take(1),
        switchMap(shippingState => {
          return this.getShoppingCartId().pipe(
            take(1),
            switchMap(cartId => {
              const data = {
                data: {
                  payment: {
                    type: typePayment,
                    payment_method_id: paymentMethodId || '',
                    device: 'web'
                  },
                  address: {
                    id: deliveryAddress.ad_id,
                  }
                  ,
                  order: {
                    shopping_cart_id: cartId,
                    tip: Number(shippingState.deliveryTip) || 0,
                    text_detail: this.textDetail,
                    shipping_cost: Number(shippingState.shippingCost) || 0,
                    distance_km: this.distance,
                  },
                  google: {
                    time: this.timeGoogle * 60,
                  }
                },
              };



              // console.log('Sending payment request with payload:', data);

              return this.http.post<PaymentCheckoutResponse>(
                `${environment.apiUrl}/checkout`,
                data,
                { headers }
              ).pipe(
                // Usamos finalize para asegurarnos de que el flag se resetea tanto en éxito como en error
                finalize(() => {
                  // console.log('Payment request completed - resetting flag');
                  this.isPaymentInProgress = false;
                  // Resetear el estado de shipping
                  this.store.dispatch(ShippingActions.resetShipping());
                  // console.log('Shipping state reset');
                }),
                catchError(error => {
                  console.error('Payment error:', error);
                  return throwError(() => ({
                    message: error.error?.message || error.message,
                    code: error.error?.code || error.code,
                    status: error.status,
                    error: error.error
                  }));
                })
              );
            })
          );
        })
      );
    } catch (error) {
      // Reset the flag if there's an exception
      this.isPaymentInProgress = false;
      // Resetear el estado de shipping en caso de excepción
      this.store.dispatch(ShippingActions.resetShipping());
      // console.log('Shipping state reset on exception');
      console.error('Payment service error:', error);
      return throwError(() => error);
    }
  }




  getShoppingCartId() {
    return this.store.select(selectShoppingCartId);
  }
}

